import React from "react";
import { BrowserRouter as Router, Route, Routes, Link } from "react-router-dom";
import { useState } from "react";
import { FiMenu } from "react-icons/fi";
import Home from "./pages/Home";
import About from "./pages/About";
import Footer from "./components/Footer";
import { FaEnvelope } from "react-icons/fa";

const App = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <Router>
      <header className="header">
        {/*<div className="logo">Adventure with Lucy</div>*/}
        <div></div>
        <nav className={menuOpen ? "nav open" : "nav"}>
          <Link to="/" onClick={() => setMenuOpen(false)}>Home</Link>
          <Link to="/about" onClick={() => setMenuOpen(false)}>About</Link>
          <a href="mailto:AdventureWithLucy@tikitribe.net?subject=Hello from your website!" onClick={() => setMenuOpen(false)}>
            <FaEnvelope />
          </a>
        </nav>
        <button className="menu-btn" onClick={() => setMenuOpen(!menuOpen)}>
          <FiMenu size={24} />
        </button>
      </header>

      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
        </Routes>
      </main>

      <style>{`
        * { margin: 0; padding: 0; box-sizing: border-box; }
        body { font-family: Arial, sans-serif; }
        .header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 20px;
          background: #fff;
          box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
        }
        .logo {
          font-size: 24px;
          font-weight: bold;
          text-align: center;
          flex-grow: 1;
        }
        .nav {
          display: flex;
          gap: 20px;
        }
        .nav a {
          text-decoration: none;
          color: #333;
          font-weight: bold;
        }
        .menu-btn {
          display: none;
          background: none;
          border: none;
          cursor: pointer;
        }
        @media (max-width: 768px) {
          .nav {
            display: none;
            flex-direction: column;
            position: absolute;
            top: 60px;
            right: 20px;
            background: white;
            box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
            padding: 10px;
          }
          .nav.open {
            display: flex;
          }
          .menu-btn {
            display: block;
          }
        }
      `}</style>
      <Footer />
    </Router>

  );
};

export default App;
